import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import PricingSection from '../../sections/auth/PricingSection/PricingSection';
import { useInitiateSubscription } from '../../APIs/Subscription/subscription';
import './subscriptionWall.css';

export default function SubscriptionWall({ isInactive }) {
  const { initiateSubscription } = useInitiateSubscription();
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const el = document.querySelector('.pc-container');
    if (!el) return;
    el.classList.toggle('sw-content-blurred', isInactive);
    return () => el.classList.remove('sw-content-blurred');
  }, [isInactive]);

  if (!isInactive) return null;

  const handleSelectPlan = async ({ planId }) => {
    setError('');
    try {
      const res = await initiateSubscription({ plan_id: planId, source: 'renewal' });
      if (res?.checkout_url) {
        window.location.href = res.checkout_url;
      } else {
        setError(res?.message || 'Could not start checkout. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <>
      <div className="sw-overlay">
        <div className="sw-overlay-card">
          <i className="ph ph-lock-key sw-lock-icon" />
          <h4>Subscription Required</h4>
          <p>Activate a plan to unlock all features.</p>
          <Button className="sw-renew-btn" onClick={() => setShowModal(true)}>
            Choose a Plan
          </Button>
        </div>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered className="subscription-plans-modal">
        <Modal.Header closeButton>
          <Modal.Title>Subscription Plans</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PricingSection onSelectPlan={handleSelectPlan} renewMode error={error} onClearError={() => setError('')} />
        </Modal.Body>
      </Modal>
    </>
  );
}
